const getFrontendBackendUrl = (): string | undefined => {
  const backendUrl = (window as { env?: { REACT_APP_BACKEND_URL?: string } }).env?.REACT_APP_BACKEND_URL;
  return typeof backendUrl === "string" ? backendUrl : undefined;
};

const getKcContextBackendUrl = (): string | undefined => {
  const kcContext = (window as { kcContext?: { properties?: Record<string, unknown> } }).kcContext;
  const backendUrl = kcContext?.properties?.BACKEND_URL;
  return typeof backendUrl === "string" ? backendUrl : undefined;
};

export const getBackendUrl = (): string => {
  const frontendUrl = getFrontendBackendUrl();
  if (frontendUrl) {
    return frontendUrl;
  }

  const kcUrl = getKcContextBackendUrl();
  if (kcUrl) {
    return kcUrl;
  }

  throw new Error("BACKEND_URL could not be resolved from window.env or kcContext.properties");
};
